import { useTranslation } from 'react-i18next';
import { ErrorType } from '../types/enums';
import MagnifyingGlass from '../../../assets/image/operationCard/Magnifying_Glass.png';
import IllustrationBikeRide from '../../../assets/image/operationCard/Illustration_BikeRide.png';
import { OperationCenterErrorCardProps } from './types/propTypes';
import styles from './OperationCenterErrorCard.module.scss';

const getErrorDetails = (type: ErrorType) => {
  let buttonLabel = `admin.errorPage.backToHome`;
  let imageUrl = '';
  let titleKey = '';
  let descriptionKey = '';
  switch (type) {
    // case ErrorType.COMING_SOON:
    //   imageUrl = csData?.coming_soon_image?.url;
    //   titleKey = 'admin.errorPage.comingSoon.title';
    //   descriptionKey = 'admin.errorPage.comingSoon.desc';
    //   break;
    case ErrorType.NO_RECORD:
      imageUrl = IllustrationBikeRide;
      titleKey = 'admin.errorPage.noRecordTitle';
      break;
    case ErrorType.NO_REWARD_AVAILABLE:
      imageUrl = IllustrationBikeRide;
      titleKey = 'admin.errorPage.noRewardAvailable';
      break;
    case ErrorType.NO_RESULT:
      imageUrl = MagnifyingGlass;
      titleKey = 'admin.errorPage.noResultTitle';
      descriptionKey = 'admin.errorPage.noResultDescription';
      break;
    case ErrorType.NOT_FOUND:
    default:
      imageUrl = MagnifyingGlass;
      titleKey = 'admin.errorPage.notFound.title';
      descriptionKey = 'admin.errorPage.notFound.desc';
  }
  return {
    buttonLabel,
    imageUrl,
    titleKey,
    descriptionKey,
  };
};

export const OperationCenterErrorCard = (props: OperationCenterErrorCardProps) => {
  const { errorType } = props;
  const { t } = useTranslation();
  const { imageUrl, titleKey, descriptionKey } = getErrorDetails(errorType);

  return (
    <div
      className={`${styles['error-card-container']} ${props.className}`}
      data-testid={`error-card-${errorType}-testid`}
    >
      <div className={styles['error-card-inner-wrapper']}>
        <div className={styles['error-card-image-container']}>
          <img src={imageUrl} alt={`${errorType}`} className={styles['error-card-image']} />
        </div>
        <div className={styles['error-card-info']}>
          <div className={styles['error-card-title']} data-testid={`title-testid`}>
            {t(titleKey)}
          </div>
          <div className={styles['error-card-description']} data-testid={`description-testid`}>
            {t(descriptionKey)}
          </div>
        </div>
        {/* <div className={styles['error-card-button']}>
          {buttonEnabled && errorType !== ErrorType.NO_RESULT && (
            <Button
              data-testid={`button-container`}
              title={t(buttonLabel)}
              buttonStyle={ButtonStyles.OUTLINE}
              onClick={onClickBtn}
              size={ButtonSize.SMALL}
              theme={Theme.PURPLE}
              buttonWidth={ButtonWidth.FIT_CONTENT}
            />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default OperationCenterErrorCard;
export { ErrorType };
export type { OperationCenterErrorCardProps };
